import { getCookieValue, setCookie } from './cookie';
import { getQueryParams } from './helpers';
import { createElement } from './registrationScripts';

export function setTapNativeCookieIfRequired() {
  try {
    if (getQueryParams().get('adv')) {
      setCookie('tapNative', window.location.search, 365);
    }
  } catch (error) {
    console.error('error setting tapNative cookie: ', error);
  }
}

export function emitTapNativeConversionEventIfApplicable() {
  try {
    const tapNativeCookie = getCookieValue('tapNative');
    if (tapNativeCookie) {
      const tapNativeConversionUrl = `https://r.tapnative.com/adx-dir-d/action${tapNativeCookie}&nid=1`;
      createElement([{
        type: 'img',
        src: tapNativeConversionUrl,
        border: 0,
        width: 1,
        height: 1,
        style: 'display:none;',
      }]);
    }
  } catch (error) {
    console.error('error setting tapNative cookie: ', error);
  }
}

export function isTapNativeCookiePresent() {
  return !!getCookieValue('tapNative');
}
